import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Globals } from "app/globals";

@Injectable()
export class AuthGuardService implements CanActivate{

    constructor(private _Globals: Globals, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        //console.log('next', route);

        if (this._Globals.userLoggedIn()) {
            //console.log('logged in');
            return true;
        } else {
            console.log('AuthGuardService block guard');
            this.router.navigate(['/login']);
            this._Globals.deleteAllStorage();
            return false;
        }

    }


}
